import React from 'react';
import { WlWindow } from 'typings/globals/cordova';
import { PLATFORMS } from '~/constants';

declare const window: WlWindow;

const platformName = PLATFORM as PLATFORMS;

export function isExcluded(excludedPlatforms: PLATFORMS[]): boolean {
  const isServer =
    window.isPreRender && excludedPlatforms.includes(PLATFORMS.SERVER);
  return isServer || excludedPlatforms.includes(platformName);
}

const ExcludeOnPlatforms =
  <P extends object>(excludedPlatforms: PLATFORMS[]) =>
  (WrappedComponent: React.ComponentType<P>) => {
    return (props: P) => {
      if (isExcluded(excludedPlatforms)) {
        return null;
      }
      return <WrappedComponent {...props} />;
    };
  };

export default ExcludeOnPlatforms;
